import React from 'react';
import { motion } from 'framer-motion';
import { assets, contactEmail } from '../../data/assets';
import { clientLogos } from '../../data/clientLogos';
import { LinkButton } from '../LinkButton';
import { SplitText } from '../SplitText';
const logoList = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.06
    }
  }
};
const logoItem = {
  hidden: {
    opacity: 0,
    y: 20,
    scale: 0.97
  },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function Brands() {
  return <section id="about" className="bg-white px-5 py-[8rem] md:px-10 md:py-[10rem] lg:py-[12rem]" data-id="element-51" data-mp="jgly0kq11kz3">
      <div className="mx-auto max-w-[71.875rem]" data-id="element-52" data-mp="5p7emcs7jhri">
        <div className="relative flex flex-col gap-10 md:flex-row md:justify-between md:gap-16 lg:gap-[10rem]" data-id="element-53" data-mp="amhbuelu8xpw">
          <div className="relative z-10 w-full max-w-[19rem] sm:max-w-[31.56rem]" data-id="element-54" data-mp="3ruch3ugvm11e">
            <SplitText as="h2" text="We take care of premium UX design and web development so you can focus on what matters most – building products people love." className="text-[2rem] font-medium leading-[1.34] tracking-[0.47px] md:text-[3.063rem] md:tracking-[0.7px]" data-id="element-55" data-mp="o9ye5qrcxsn" />
          </div>
          <div className="relative z-10 w-full max-w-[20rem] sm:max-w-[27.75rem] md:mt-[10rem]" data-id="element-56" data-mp="39q3l1rk7s4ec">
            <SplitText as="p" text="At Immersive, we combine UX/UI design, web development and brand identity with a touch of real-time 3D. We take care of everything website-related and deliver design for apps, web, marketing and social – along with interactive 3D experiences that leave a lasting impression. Think of us as a design partner that turns bold ideas into exceptional work." className="text-[1rem] font-normal leading-[1.78] tracking-[0.5px] text-black sm:text-[1.25rem] md:text-[1.94rem] md:tracking-[0.78px]" data-id="element-57" data-mp="35r4igdlygjq2" />
          </div>
          <div aria-hidden="true" className="pointer-events-none absolute inset-0 -mt-[3.5rem] hidden flex-col items-center md:flex" data-id="element-58" data-mp="1u9uzrtanhvpt">
            <img src={assets.logo3d} alt="" className="-ml-[16.5rem] -mt-[0.3rem] w-[7rem] lg:-ml-[8rem] lg:-mt-[1.4rem] lg:w-[8.75rem]" data-id="element-59" data-mp="3tdbkg0v79wsu" />
          </div>
        </div>

        <div className="h-[4.5rem] md:h-[8rem] lg:h-[12rem]" data-id="element-60" data-mp="bywm5t381ac2" />

        <motion.ul aria-label="Clients we have worked with" variants={logoList} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-2 items-center justify-items-center gap-x-10 gap-y-10 sm:grid-cols-3 sm:gap-y-12 md:gap-y-16 lg:grid-cols-5 lg:gap-x-8 lg:gap-y-[5.5rem]" data-id="element-61" data-mp="by4rckhg7gmu">
          {clientLogos.map(logo => <motion.li key={logo.name} variants={logoItem} className="flex h-[3.5rem] w-full items-center justify-center" data-id="element-62" data-mp="zoh90n2hwrqm">
              <img src={logo.src} alt={logo.name} style={{
            width: `${(logo.width ?? 110) / 16}rem`
          }} className="h-auto max-h-full max-w-full object-contain" data-id="element-63" data-mp="14msk114j18af" />
            </motion.li>)}
        </motion.ul>

        <div className="h-[4rem] md:h-[6rem] lg:h-[8rem]" data-id="element-64" data-mp="2ff9ovkyhw546" />

        <div className="flex justify-center" data-id="element-65" data-mp="2fdq8lucu9u2e">
          <LinkButton label="Get in touch" href={`mailto:${contactEmail}`} data-id="element-66" data-mp="2ahhy4u9l6p1k" />
        </div>
      </div>
    </section>;
}